import React, { useState, useContext, useEffect } from "react";
import "./adminLanding.css";
import CircularProgress from '@mui/material/CircularProgress';
import ManageUser from "./images/manage_user.svg";
import Question from "./images/questions.svg";
import EmailConfiguration from "./images/email_config.svg";
import Domain from "./images/domain.svg";
import Skill from "./images/skills.svg";
import SubSkill from "./images/subskill.svg";
import ReportedQuestion from "./images/reorted_questions.svg";
import SearchCandidate from "./images/search_candidates.svg";
import { useNavigate } from "react-router-dom";
import { UserTypeContext } from "../../AppRoute";
import UnauthorizedAccess from "../../components/UnauthorizedAccess/UnauthorizedAccess";
const AdminLanding = ({ idContextTest }) => {
  const { userType } = useContext(UserTypeContext);
  const history = useNavigate();
  const [loadingController, setLoadingController] = useState(false);
  useEffect(() => {
    (async () => {
      if (userType) {
        setLoadingController(true)
      }
    })()
    return () => {
      setLoadingController(false)
    }
  }, [userType])

  return (
    <>

      {!loadingController ? (
        <div className="row circular-progress-center-question text-center">
          <CircularProgress />
        </div>
      ) : (
        <>
          {userType === "Admin" ? (
            <>
              <div className="admin-dashboard">
                {/* Admin Header */}
                <p className="header-admin-dashboard">
                    Admin Navigation
                </p>
                
                {/* Tests & Questions Section */}
                <div className="section-container">
                  <div className="section-header">
                    <h2 className="section-title">Tests & Questions</h2>
                  </div>

                  <div className="cards-grid">
                    <div
                      className="admin-card"
                      onClick={() => history("/questions")}
                    >
                      <div className="card-icon questions-icon">
                        <img src={Question} alt="questions" />
                      </div>
                      <h3 className="card-title">Questions</h3>
                    </div>

                    <div
                      className="admin-card"
                      onClick={() => history("/subskill")}
                    >
                      <div className="card-icon subskills-icon">
                        <img src={SubSkill} alt="subskill" />
                      </div>
                      <h3 className="card-title">Sub-Skills</h3>
                    </div>

                    <div
                      className="admin-card"
                      onClick={() => history("/skills")}
                    >
                      <div className="card-icon skills-icon">
                        <img src={Skill} alt="skills" />
                      </div>
                      <h3 className="card-title">Skills</h3>
                    </div>

                    <div
                      className="admin-card"
                      onClick={() =>
                        history("/client-specific-test-access")
                      }
                    >
                      <div className="card-icon access-icon">
                        <img src={SubSkill} alt="client-specific-access" />
                      </div>
                      <h3 className="card-title">Client-Specific Test Access</h3>
                    </div>

                    <div
                      className="admin-card"
                      onClick={() => history("/tests")}
                    >
                      <div className="card-icon tests-icon">
                        <img src={SubSkill} alt="tests" />
                      </div>
                      <h3 className="card-title">Tests</h3>
                    </div>

                    <div
                      className="admin-card"
                      onClick={() => history("/domain")}
                    >
                      <div className="card-icon domains-icon">
                        <img src={Domain} alt="domain" />
                      </div>
                      <h3 className="card-title">Domains</h3>
                    </div>
                  </div>
                </div>

                {/* Users & Clients Section */}
                <div className="section-container">
                  <div className="section-header">
                    <h2 className="section-title">Users & Clients</h2>
                  </div>

                  <div className="cards-grid">
                    <div
                      className="admin-card"
                      onClick={() => history("/users")}
                    >
                      <div className="card-icon users-icon">
                        <img src={ManageUser} alt="manage_user" />
                      </div>
                      <h3 className="card-title">Manage Users</h3>
                    </div>

                    <div
                      className="admin-card search-candidate-card"
                      onClick={() => history("/search")}
                    >
                      <div className="card-icon search-icon-admin-menu">
                        <img src={SearchCandidate} alt="search_candidates" />
                      </div>
                      <h3 className="card-title">Search Candidates</h3>
                    </div>

                    <div
                      className="admin-card"
                      onClick={() => history("/sign-up-requests")}
                    >
                      <div className="card-icon signup-icon">
                        <img src={EmailConfiguration} alt="sign_up_requests" />
                      </div>
                      <h3 className="card-title">Sign-Up Requests</h3>
                    </div>

                    <div
                      className="admin-card"
                      onClick={() =>
                        history(
                          "/recruitment-organizations-customers-and-agencies"
                        )
                      }
                    >
                      <div className="card-icon orgs-icon">
                        <img src={SubSkill} alt="organizations" />
                      </div>
                      <h3 className="card-title">Recruitment Organizations</h3>
                    </div>

                    <div
                      className="admin-card"
                      onClick={() => history("/admin-referral")}
                    >
                      <div className="card-icon referral-icon">
                        <img src={SubSkill} alt="referral" />
                      </div>
                      <h3 className="card-title">Referral</h3>
                    </div>
                  </div>
                </div>

                {/* Configuration Section */}
                <div className="section-container">
                  <div className="section-header">
                    <h2 className="section-title">Configuration</h2>
                  </div>

                  <div className="cards-grid">
                    <div
                      className="admin-card"
                      onClick={() => history("/globalconfiguration")}
                    >
                      <div className="card-icon config-icon">
                        <img src={EmailConfiguration} alt="global_config" />
                      </div>
                      <h3 className="card-title">Global Configuration</h3>
                    </div>

                    <div
                      className="admin-card"
                      onClick={() => history("/emailconfiguration")}
                    >
                      <div className="card-icon email-icon">
                        <img src={EmailConfiguration} alt="email_config" />
                      </div>
                      <h3 className="card-title">Email Configuration</h3>
                    </div>

                    <div
                      className="admin-card"
                      onClick={() =>
                        history("/pending-candidate-invites")
                      }
                    >
                      <div className="card-icon invites-icon">
                        <img src={SubSkill} alt="pending_invites" />
                      </div>
                      <h3 className="card-title">Pending Invites</h3>
                    </div>

                    <div
                      className="admin-card"
                      onClick={() => history("/reported-question")}
                    >
                      <div className="card-icon reports-icon">
                        <img src={ReportedQuestion} alt="reported_questions" />
                      </div>
                      <h3 className="card-title">Reported Questions</h3>
                    </div>
                  </div>
                </div>
              </div>
            </>
          ) : userType === "" ? (<>
            <div className="row padding_80 text-center">
              <p className="fs-semi-bold fs-40 f-color">
                Loading...</p>
            </div>
          </>) : (
            <UnauthorizedAccess />
          )}
        </>
      )}

    </>
  );
};
export default AdminLanding;
